import clsx from 'clsx';
import { type ForwardedRef, forwardRef } from 'react';

import {
    CardButton,
    type CardButtonProps,
    HeadingContext,
    type IconDefinition,
    renderIcon,
} from '@gitbook/spine-react';

export const SiteQuickActionCard = forwardRef(function SiteQuickActionCard(
    props: CardButtonProps,
    ref: ForwardedRef<HTMLDivElement>
) {
    return (
        <CardButton
            ref={ref}
            {...props}
            className={clsx(
                'flex flex-col items-center justify-center gap-3 rounded-md border border-base border-solid bg-base p-4 text-center',
                props.className
            )}
        >
            <HeadingContext.Provider value={{ level: 3, className: 'text-ui-base' }}>
                {props.children}
            </HeadingContext.Provider>
        </CardButton>
    );
});

export function SiteQuickActionCardIcon(props: { children: IconDefinition }) {
    return (
        <div className="flex items-center justify-center rounded-lg border p-2">
            {renderIcon(props.children, {
                className: 'size-4 text-secondary',
            })}
        </div>
    );
}
